import React from "react";

export default function Hero({ progression, metrics, selectedShop }) {
  const isLvl1Done = progression?.isLevel1Completed;
  const target = progression?.nextTargetTier || {
    id: 1,
    name: "Bronze Starter",
    clientsRequired: 25,
    connectRequired: 50,
    ratingRequired: 3.5,
    benefits: [
      "1st Region Unlocked (Primary Hub / Lahore HQ)",
      "Standard Agent Portal & Basic Client Directory",
    ],
    clientsRemaining: 25,
    connectRemaining: 50,
    progressPercent: 0,
    prevTierThreshold: 0,
  };

  const totalClients = metrics?.totalClients ?? 0;
  const clientsRemaining = target.clientsRemaining ?? 0;
  const progressPercent = target.progressPercent ?? 0;
  const prevThreshold = target.prevTierThreshold ?? 0;
  const benchmark = target.clientsRequired ?? 25;

  const scrollToRoadmap = () => {
    const el = document.getElementById("roadmap-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="marketing_level_hero rounded-4 marketing_level_hero_pad mb-4 shadow">
      <div className="marketing_level_hero_grid">
        <div className="marketing_level_min0">
          <span className="badge marketing_level_hero_pill rounded-pill px-3 py-2 mb-3 text-uppercase">
            <i
              className="bi bi-circle-fill text-success me-2"
              style={{ fontSize: 8 }}
            />
            Active Assignment: {selectedShop?.city || "Lahore Operational HQ"}
          </span>

          <h2 className="fw-bold marketing_level_hero_title mb-3">
            {clientsRemaining > 0
              ? `You are ${clientsRemaining} Clients away from Level ${target.id} (${target.name})`
              : `Level ${target.id} (${target.name}) Milestones Satisfied!`}
          </h2>

          <p className="opacity-75 mb-4">
            {target.id === 1 ? (
              <>
                Completing Level 1 unlocks your{" "}
                <strong>1st Region (Primary Hub / Lahore HQ)</strong>, activates
                your <strong>5.0% Base Commission</strong>, and entitles you to the
                SelectEzi Verified Bronze Starter milestone badge.
              </>
            ) : target.id === 2 ? (
              <>
                Elevating to Silver activates your{" "}
                <strong>6.0% commission cut</strong> (+100 bps perk), opens the
                Client Referral Network, and grants Standard Payout Gateway
                access.
              </>
            ) : target.id === 3 ? (
              <>
                Elevating to Gold unlocks your{" "}
                <strong>2nd Regional Territory (Karachi Hub)</strong>, raises
                your commission cut from <strong>6.0% to 7.0%</strong> (+100 bps),
                and entitles you to the SelectEzi Featured Directory verified badge.
              </>
            ) : (
              <>
                Elevating to Level {target.id} unlocks higher commission tiers,
                broadens regional territorial authority across Pakistan, and expands
                enterprise network leads.
              </>
            )}
          </p>

          <div className="d-flex flex-wrap gap-1 justify-content-between small fw-semibold mb-2">
            <span>
              Client Threshold: {totalClients} of {benchmark} Clients (
              {progressPercent}% Complete)
            </span>
            <span>
              {clientsRemaining > 0
                ? `${clientsRemaining} Clients Remaining`
                : "Requirement Met ✓"}
            </span>
          </div>

          <div
            className="progress marketing_level_hero_bar"
            style={{ height: 8 }}
            role="progressbar"
            aria-valuenow={progressPercent}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            <div
              className="progress-bar"
              style={{ width: `${Math.min(100, progressPercent)}%` }}
            />
          </div>

          <div className="d-flex flex-wrap gap-1 justify-content-between small opacity-75 mt-2">
            <span>Tier Baseline: {prevThreshold} Clients</span>
            <span>Qualification Benchmark: {benchmark} Clients</span>
          </div>
        </div>

        <div className="marketing_level_min0">
          <div className="marketing_level_hero_glass rounded-4 p-3 h-100 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <span className="small fw-bold text-uppercase opacity-75">
                  Next Unlock Package
                </span>
                <span className="badge bg-warning text-dark">
                  Level {target.id} {target.name.split(" ")[0]}
                </span>
              </div>
              <ul className="list-unstyled small mb-3">
                {(target.benefits || []).slice(0, 3).map((b, i) => (
                  <li key={i} className="d-flex gap-2 mb-2">
                    <i
                      className={`bi ${
                        i === 0
                          ? "bi-shield-check text-info"
                          : i === 1
                          ? "bi-graph-up-arrow text-success"
                          : "bi-headset text-warning"
                      }`}
                    />
                    <span>{b}</span>
                  </li>
                ))}
              </ul>
            </div>

            <button
              type="button"
              className="btn btn-light w-100 fw-semibold text-primary shadow-sm"
              onClick={scrollToRoadmap}
            >
              Inspect Level {target.id} Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

